import { useEffect, useState } from "react";
import { WelcomePage } from "./welcome";
import { InfoSourcesPage } from "./info-sources";
import { ExercisePageCurrent1 } from "./exercise-page-current-1";
import { ExercisePageCurrent2 } from "./exercise-page-current-2";
import { ExercisePagePast1 } from "./exercise-page-past-1";
import { ExercisePageLegal1 } from "./exercise-page-legal-1";
import { ExercisePageOthers1 } from "./exercise-page-others-1";
import { ExercisePageTitle1 } from "./exercise-page-last-1";
import { PostReviewPage } from "./post-review";
import { ClassroomContextProvider } from "../components/classroom.context";
import { sendPageEvent } from "../components/analytics";

export function StudentApp() {
  const [step, setStep] = useState("START");

  useEffect(() => {
    const goBack = (event) => {
      event.preventDefault();
      setStep(event.state?.step || "START");
    };
    window.addEventListener("popstate", goBack);
    return () => window.removeEventListener("popstate", goBack);
  }, []);

  useEffect(() => {
    if (!import.meta.env.PROD) return;

    if (step !== "START") sendPageEvent(step.toLowerCase());
  }, [step]);

  const goToStep = (step) => {
    setStep(step);
    window.history.pushState({ step }, "", window.location.toString());
  };

  return (
    <ClassroomContextProvider>
      {step === "START" && <WelcomePage onNext={() => goToStep("SOURCES")} />}
      {step === "SOURCES" && (
        <InfoSourcesPage
          onPrevious={() => goToStep("START")}
          onNext={() => goToStep("CURRENT_1")}
        />
      )}
      {step === "CURRENT_1" && (
        <ExercisePageCurrent1
          onPrevious={() => goToStep("SOURCES")}
          onNext={() => goToStep("CURRENT_2")}
        />
      )}
      {step === "CURRENT_2" && (
        <ExercisePageCurrent2
          onPrevious={() => goToStep("CURRENT_1")}
          onNext={() => goToStep("PAST_1")}
        />
      )}
      {step === "PAST_1" && (
        <ExercisePagePast1
          onPrevious={() => goToStep("CURRENT_2")}
          onNext={() => goToStep("LEGAL_1")}
        />
      )}
      {step === "LEGAL_1" && (
        <ExercisePageLegal1
          onPrevious={() => goToStep("PAST_1")}
          onNext={() => goToStep("OTHERS_1")}
        />
      )}
      {step === "OTHERS_1" && (
        <ExercisePageOthers1
          onPrevious={() => goToStep("LEGAL_1")}
          onNext={() => goToStep("TITLE_1")}
        />
      )}
      {step === "TITLE_1" && (
        <ExercisePageTitle1
          onPrevious={() => goToStep("OTHERS_1")}
          onNext={() => goToStep("POST_REVIEW")}
        />
      )}
      {step === "POST_REVIEW" && (
        <PostReviewPage onPrevious={() => goToStep("CURRENT_1")} />
      )}
    </ClassroomContextProvider>
  );
}
